export default __webpack_public_path__ + "static/media/kestrel3.18b1bf03.jpg";